import { BootstrapBrowserBuilder } from '@zg-rentals/rp-bootstrap-browser';

export const bootstrap = new BootstrapBrowserBuilder('hotpads-web', Number(__BUILD_NUMBER__))
  .withLoggerOptions({
    logPath: '/log',
    level: 'info',
  })
  .withDatadogPlugin('4452a0aa-8e05-45d3-92c8-fccb387b1b36', 'pub37ad464f2f14ee1f30374e404b5140a6')
  .build();
